import TiposDeMovimientosDashboardTable from 'components/tables/TiposDeMovimientosDashboardTable';
import React, {useState} from 'react';

interface TiposDeMovimientosDashboardProps {
  tiposRows: TiposRow[];
}

// Define the interface for each row in procRows
interface TiposRow {
  id: string;
  nombre: string;
  descripcion: string;
  clase: string;
  titulo: string;
  texto: string;
  informe: string;
  proximo_paso: string;
  ppEnCuantosDias: number;
  estado: string;
}


const TiposDeMovimientosDashboard: React.FC<TiposDeMovimientosDashboardProps> = ({ tiposRows }) => {
  return (
    <>
      {console.log("tiposRows in Dashboard: ", tiposRows)}
      <TiposDeMovimientosDashboardTable tiposRows={tiposRows} />
    </>
  );
};

export default TiposDeMovimientosDashboard;

